import { useEffect } from "react";
import { ArrowLeft, Scale } from "lucide-react";
import { TERMS_VERSION } from "../../constants/legal";
import { WhatsAppButton } from "../landing/WhatsAppButton";

const LINKS = [["/terms", "Terms"], ["/privacy", "Privacy"], ["/disclaimer", "Disclaimer"]];

export const LegalPage = ({ slug, title, summary, sections }) => {
  useEffect(() => {
    document.title = `${title} · Balangir Group`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="min-h-screen bg-[#0B1120] font-body text-slate-100">
      <header className="border-b border-slate-800 bg-slate-900/90">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4 sm:px-6">
          <a href="/" data-testid={`${slug}-logo-link`} className="flex items-center gap-2.5">
            <span className="font-heading text-lg font-extrabold text-white">Balangir Group</span>
          </a>
          <a href="/" data-testid={`${slug}-back-link`} className="flex items-center gap-2 text-sm text-slate-300 hover:text-orange-400">
            <ArrowLeft className="h-4 w-4" />Back to website
          </a>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:py-20">
        <p className="eyebrow">Legal · Updated {TERMS_VERSION}</p>
        <h1 data-testid={`${slug}-title`} className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{title}</h1>
        <nav className="mt-6 flex gap-5 text-sm">
          {LINKS.map(([href, label]) => (
            <a key={href} href={href} data-testid={`${slug}-nav-${label.toLowerCase()}`}
              className={href === `/${slug}` ? "font-semibold text-orange-400" : "text-slate-400 hover:text-white"}>{label}</a>
          ))}
        </nav>
        <div data-testid={`${slug}-summary`} className="mt-10 flex gap-4 border-l-2 border-orange-500 bg-[#0F172A] p-6">
          <Scale className="mt-1 h-6 w-6 shrink-0 text-orange-400" />
          <p className="leading-relaxed text-slate-200">{summary}</p>
        </div>
        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.id} data-testid={`${slug}-section-${s.id}`}>
              <h2 className="font-heading text-xl font-bold text-white">{s.title}</h2>
              {s.body.map((p) => <p key={p.slice(0, 40)} className="mt-3 leading-relaxed text-slate-400">{p}</p>)}
            </section>
          ))}
        </div>
      </main>
      <WhatsAppButton />
    </div>
  );
};
